import React from 'react';
import { useGetOrdersQuery } from '@src/features/order/redux';
import { OrderGroupEntity } from '@src/features/order/entities';
import { IOrderContext } from './types';
import { ArcSocketContext } from '@src/core/socket/base';
import { ChannelResponseEnum } from '@src/core/socket';

export const OrderContext = React.createContext<IOrderContext>({
  isLoading: false,
  refetch: () => {},
  data: {} as OrderGroupEntity,
});

const EMPTY_ORDER_GROUP: OrderGroupEntity = {} as OrderGroupEntity;

export const OrderProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { subscribe, unsubscribe, readyState } = React.useContext(ArcSocketContext);
  // Socket-driven updates via UPDATE_ORDERS; fall back to polling only when socket is down.
  const { data = EMPTY_ORDER_GROUP, refetch, isLoading } = useGetOrdersQuery(undefined, {
    pollingInterval: readyState ? 0 : 15000,
  });

  React.useEffect(() => {
    subscribe(ChannelResponseEnum.UPDATE_ORDERS, () => refetch());
    return () => unsubscribe(ChannelResponseEnum.UPDATE_ORDERS);
  }, [subscribe, unsubscribe, refetch]);

  const value = React.useMemo(() => ({
    data,
    refetch,
    isLoading,
  }), [data, refetch, isLoading]);

  return (
    <OrderContext.Provider value={value}>
      {children}
    </OrderContext.Provider>
  );
};
